import { ImportWithTemplateModal } from "@qivia/ui";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { selectCompany } from "../../../homeSlice";
import { uploadVehicleContractDataAsync } from "../contractFollowUp/vehicleContractDataSlice";
import {
  CONTRACT_DATA_COLUMNS,
  getContractDataHeaderErrors,
  getContractDataLineErrors,
  parseContractDataFile,
} from "../contractFollowUp/contractDataErrors";
import "../../../../../i18n/i18n";

const CONTRACT_DATA_TEMPLATE_FILE_NAME = "fichier_d_import_de_contrats.xlsx";

export type ImportContractDataModalProps = {
  visible: boolean;
  onCloseModal: () => void;
};

export const ImportContractDataModal = (
  props: ImportContractDataModalProps,
) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);

  return (
    <ImportWithTemplateModal
      visible={props.visible}
      onCloseModal={props.onCloseModal}
      title={t("fleet.advanced_analytics.importContract.title")}
      returnButtonText={t(
        "fleet.advanced_analytics.importContract.button.return",
      )}
      template={{
        fileName: CONTRACT_DATA_TEMPLATE_FILE_NAME,
        columns: [...CONTRACT_DATA_COLUMNS],
        sheetName: "Contrats",
      }}
      validateRows={(rows) => [
        ...getContractDataHeaderErrors(rows[0] ?? []),
        ...getContractDataLineErrors(rows),
      ]}
      onSubmit={(file) => {
        if (!company) return;
        void parseContractDataFile(file).then((vehicles) => {
          void dispatch(
            uploadVehicleContractDataAsync({
              vehicles,
              companyUuid: company.uuid,
            }),
          );
        });
      }}
      errorTypeToLabel={(errorType) =>
        t(`fleet.advanced_analytics.importContract.errorType.${errorType}`)
      }
    />
  );
};
